module.exports = __webpack_public_path__ + "img/donante-centro-anciano.815d60f0.png";